import { render, staticRenderFns } from "./MatureAudienceLoginModal.vue?vue&type=template&id=280218c7&"
import script from "./MatureAudienceLoginModal.vue?vue&type=script&lang=js&"
export * from "./MatureAudienceLoginModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports